function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".creditcard_sm_svg__a{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 24,
  rx: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "creditcard_sm_svg__a",
  d: "M0 4h36v4H0zM2 10h20v4H2zM24 10h10v4H24z"
});

function SvgCreditcardSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 24"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNiAyNCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PHJlY3Qgd2lkdGg9IjM2IiBoZWlnaHQ9IjI0IiByeD0iMiIvPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNCkiPjxyZWN0IGNsYXNzPSJhIiB3aWR0aD0iMzYiIGhlaWdodD0iNCIvPjwvZz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyIDEwKSI+PHJlY3QgY2xhc3M9ImEiIHdpZHRoPSIyMCIgaGVpZ2h0PSI0Ii8+PC9nPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0IDEwKSI+PHJlY3QgY2xhc3M9ImEiIHdpZHRoPSIxMCIgaGVpZ2h0PSI0Ii8+PC9nPjwvc3ZnPgo=";
export { SvgCreditcardSm as ReactComponent };